import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getTokenExpiry } from "./CommonUtils/TimeUtility";

export default function RequireAuth() {
    const location = useLocation();

    if (!isAuthenticated()) {
        return (
            <Navigate
                to="/unauthorized"
                replace
                state={{
                    from: location.pathname,
                    message: "Your session is not active. Please login to continue.",
                }}
            />
        );
    }

    return <Outlet />;
}

export const isAuthenticated = () => {
    const token = sessionStorage.getItem("token");
    if (!token) return false;

    const tokenTime = Number(sessionStorage.getItem("tokenTime"));
    const tokenExpiry = Number.isFinite(tokenTime) && tokenTime > 0
        ? tokenTime
        : getTokenExpiry(token);

    if (!tokenExpiry || tokenExpiry <= Date.now()) {
        clearAuthSession();
        return false;
    }

    return true;
};

export const clearAuthSession = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("tokenTime");
    sessionStorage.removeItem("refreshTokenTime");
    sessionStorage.clear();
};
